import React from 'react';
import GroupMemberInviteModal from '../GroupMemberInviteModal';

interface GroupMemberInviteModalMobileProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

const GroupMemberInviteModalMobile: React.FC<GroupMemberInviteModalMobileProps> = ({
  setIsUserInput,
}) => (
  <GroupMemberInviteModal isMobile setIsUserInput={setIsUserInput} />
);

export default GroupMemberInviteModalMobile;
